"use client";

import useRouter from "@stadium/hooks/lib/use-custom-route";
import { useWorkspaceContext } from "@stadium/hooks/lib/workspace";

import StorePreviewImage from "@sharedComponents/store-preview-image";
import { InternalButton } from "@sharedComponents/buttons";

import { getCreateNewShopRoute } from "@stadium/helpers/app-routes";

import { SM_API_HOST } from "@stadium/constants/api-endpoints";
import { BASE_SHOPS_PATH } from "@stadium/constants/routes";
import { LOGIN_CALLBACK_ROUTE, useAuth0V2 } from "@stadium/services/auth0";

import { getOriginLoginParams } from "@stadium/services/auth/utils";

import styles from "./main.module.scss";

export const TemplateView = ({ name, number, topBanner, productsThumbImage }) => {
  const { isAuthenticated, loginWithRedirect } = useAuth0V2();
  const router = useRouter();
  const { workspaceSlug } = useWorkspaceContext();
  const useTemplateUrl = getCreateNewShopRoute({ shopNumber: number, workspaceSlug });

  const onTemplateSelect = () => {
    if (isAuthenticated) {
      router.push(useTemplateUrl);
    } else {
      loginWithRedirect({
        redirectUri: window.location.origin + BASE_SHOPS_PATH + LOGIN_CALLBACK_ROUTE,
        appState: { returnTo: useTemplateUrl },
        apiHost: SM_API_HOST,
        signUp: true,
        ...getOriginLoginParams(),
      });
    }
  };

  return (
    <InternalButton
      className={styles.shopTemplateButton}
      onClick={onTemplateSelect}
      styleType="no-style"
    >
      <StorePreviewImage
        topBanner={topBanner}
        productsThumbImage={productsThumbImage}
        width={554}
        height={443}
        fallbackImgClassName={styles.shopTopImage}
        imgClassName={styles.shopBottomImage}
        className={styles.imageWrapper}
      />
      <h4 className={styles.shopTemplateName}>{name}</h4>
    </InternalButton>
  );
};
